import controller from './category.controller';
import template from './category.view.html';

let CategoryComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default CategoryComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/category/category.component.js
 **/